export default __webpack_public_path__ + "static/media/investor-1.eeb12be8.jpg";